import { styled, withTheme } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";

interface CardProps {
  variant?: "flat";
  regular?: boolean;
  theme: any;
}
const Card = styled(Box)({
  boxSizing: "border-box",
  borderRadius: (props: CardProps) => (props.regular ? 10 : 20),
  textAlign: "center",
  backgroundColor: (props: CardProps) =>
    props.variant === "flat" ? props.theme.palette.grey200.main : props.theme.palette.background.default,
  boxShadow: (props: CardProps) => (props.variant === "flat" ? "none" : "1px 1px 16px 1px rgb(0 0 0 / 12%)"),
});

export default withTheme(Card);
